import React, { useContext, useEffect, useState, useMemo } from 'react';

// Packs
import { FormRendererStateProvider } from 'packs/form-renderer';

// Components
import LandingPageHeader from 'shared/components/LandingPageHeader';
import WebinarBadge from 'shared/components/Badges/WebinarBadge';
import LiveTrainingBadge from 'shared/components/Badges/LiveTrainingBadge';
import ConfirmationPageDetails from 'shared/components/ConfirmationPageDetails';

// Assets
import ConfirmationBackgroundImage from 'assets/images/webinar-confirmation.svg';
const colors = require('shared/~bravely/variables/_colors.module.scss').default;

// Context
import WebinarsContext from 'webinars/context';

// Helpers
import { WEBINAR_CUT_OFF } from 'webinars/shared/helpers';
import { getPostSurveyCtaProps } from 'webinars/pages/WebinarWatchPage/helpers';

//Utils
import BravelyData from 'utils/data';

// Styles
import '../WebinarRegistrationPage/styles';
import './styles.scss';

const WebinarRatingPage = () => {
  // States
  const [showRatings, setShowRatings] = useState(false);

  const { webinar = {} } = useContext(WebinarsContext);
  const { isLiveTraining } = webinar;
  const hasUpcomingSession = BravelyData('hasUpcomingSession');

  useEffect(() => {
    if (!BravelyData('useZoomSdk')) {
      return setShowRatings(true);
    }

    const timeSinceWebinarStart =
      Date.parse(new Date()) - Date.parse(webinar.scheduledDate);

    const webinarEnded = timeSinceWebinarStart > WEBINAR_CUT_OFF;

    if (!webinarEnded) {
      window.location = `/webinars/${webinar.encodedId}`;
    }
    setShowRatings(webinarEnded);
  }, []);

  const { name = 'Bravely Webinar', formatted_date: formattedDate } = webinar;

  const viewComponentProps = {
    ctaProps: getPostSurveyCtaProps({
      webinar,
      hasUpcomingSession,
      isLiveTraining,
    }),
    backgroundImg: ConfirmationBackgroundImage,
  };

  return (
    <>
      <LandingPageHeader
        title={name}
        date={formattedDate}
        badge={isLiveTraining ? <LiveTrainingBadge /> : <WebinarBadge />}
        styleOverrides={
          isLiveTraining ? { backgroundColor: colors.greenNeutral } : {}
        }
      />
      {showRatings && (
        <div className="rating-page-container">
          <FormRendererStateProvider
            ViewComponent={ConfirmationPageDetails}
            viewComponentProps={viewComponentProps}
          />
        </div>
      )}
    </>
  );
};

export default WebinarRatingPage;
